(function () {
  'use strict';

  var LANGUAGE_COUNTRY = {
    en: { c: 'US', p: '+1' },
    fr: { c: 'FR', p: '+33' },
    it: { c: 'IT', p: '+39' },
    es: { c: 'ES', p: '+34' },
    de: { c: 'DE', p: '+49' },
    he: { c: 'IL', p: '+972' },
    'pt-pt': { c: 'PT', p: '+351' },
    'pt-br': { c: 'BR', p: '+55' },
    pt: { c: 'BR', p: '+55' }
  };

  function localeDefault() {
    var lang = String(document.documentElement.lang || 'en').toLowerCase();
    return LANGUAGE_COUNTRY[lang] || LANGUAGE_COUNTRY[lang.split('-')[0]] || LANGUAGE_COUNTRY.en;
  }

  function applyToTrigger(trigger) {
    if (!trigger || trigger.dataset.pmyLocaleDefaultApplied === '1') return false;
    if (trigger.dataset.pmyUiV2 !== '1') return false;

    var target = localeDefault();
    var code = document.getElementById('prefix-code');
    if (!code) return false;

    trigger.click();
    var options = document.querySelectorAll('.pmy-country-panel .pmy-select-option');
    var wanted = null;
    Array.prototype.some.call(options, function (option) {
      var cc = option.querySelector('.pmy-country-code');
      if (cc && cc.textContent.trim().toUpperCase() === target.c) {
        wanted = option;
        return true;
      }
      return false;
    });

    if (!wanted) {
      if (trigger.getAttribute('aria-expanded') === 'true') trigger.click();
      return false;
    }

    wanted.click();
    trigger.dataset.pmyLocaleDefaultApplied = '1';
    return true;
  }

  function applyAll() {
    var trigger = document.getElementById('phone-prefix-trigger');
    if (trigger) applyToTrigger(trigger);
  }

  function start() {
    applyAll();

    var observer = new MutationObserver(function () {
      applyAll();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('pageshow', applyAll);
    document.addEventListener('shopify:section:load', applyAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
